import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { InputBoxModule } from '../input-box/input-box.module';
import { ListModule } from '../list/list.module';
import { SelectBoxComponent } from './select-box.component';

@NgModule({
  imports: [
    CommonModule,
    InputBoxModule,
    DropdownModule,
    ListModule,
    ButtonModule,
  ],
  declarations: [SelectBoxComponent],
  exports: [SelectBoxComponent],
})
export class SelectBoxModule {}
